import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=6585afd6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6585afd6"]])

export default __exports__